module.exports = __webpack_public_path__ + "media/assets/images/flags/td-785fc43663171d944871d40ffd6b7021.svg";